import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import { constructQueryString } from "../../Util/HelperFunction";

export const schoolcreateAction = createAsyncThunk(
  "school/create",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/school/create", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const multiTeachercreateAction = createAsyncThunk(
  "school/multiTeacher",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/teacher/csv", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const multiStudentcreateAction = createAsyncThunk(
  "school/multiStudent",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/student/csv", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolCsvListAction = createAsyncThunk(
  "school/schoolCsvlist",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/school/csv/download?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoollistAction = createAsyncThunk(
  "school/list",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/school/list?${query}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const organisationalSchoolListAction = createAsyncThunk(
  "school/organisationalSchoolList",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(
        `/organisation-group/${reqBody?.id}/organisations/list?page=${reqBody.page}&limit=${reqBody.limit}${reqBody.search ? `&search=${reqBody.search}` : ''}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const schoolStatsAction = createAsyncThunk(
  "school/stats",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/school-stats?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schooldeleteAction = createAsyncThunk(
  "school/delete",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.delete(`/school/delete?id=${reqBody?.id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schooldetailsAction = createAsyncThunk(
  "school/details",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`/school/details?id=${reqBody.id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolTeacherIdListAction = createAsyncThunk(
  "school/techerlist",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `/school/teacher?schoolId=${reqBody.id}&search=${reqBody?.searchValue}`,
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolStudentIdListAction = createAsyncThunk(
  "school/studentlist",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `/school/student?schoolId=${reqBody.id}&search=${reqBody?.searchValue}`,
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolParentIdListAction = createAsyncThunk(
  "school/parentlist",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `/school/parent?schoolId=${reqBody.id}&search=${reqBody?.searchValue}`,
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolNewAdminsList = createAsyncThunk(
  "school/newAdminsList",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/school/school-admins?${query}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolAdminListAction = createAsyncThunk(
  "school/adminList",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody || {});
      const response = await Api.get(`/school/school-admins/list?${query}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updateAction = createAsyncThunk(
  "school/update",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put(`/school/update`, reqBody);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const suspendAction = createAsyncThunk(
  "school/suspend",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/school/suspend", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
export const schoolResetPassAction = createAsyncThunk(
  "school/reset-password",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put(`school/reset-password`, reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const schoolAssignGroupAction = createAsyncThunk(
  "school/assignGroup",
  async ({ schoolIds, organisationGroupId }, thunkAPI) => {
    try {
      const response = await Api.post(
        `/organisation-group/${organisationGroupId}/organisations/add`,
        { schoolIds },
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const schoolRemoveGroupAction = createAsyncThunk(
  "school/removeGroup",
  async (id, thunkAPI) => {
    try {
      const response = await Api.delete(
        `/organisation-group/organisations/delete/${id}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const schoolRemoveMembersAction = createAsyncThunk(
  "school/removeMembers",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.patch("/school/remove-members", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const schoolReassignStudentAction = createAsyncThunk(
  "school/reassignStudent",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.patch("/school/reassign-student", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const schoolReassignParentAction = createAsyncThunk(
  "school/reassignParent",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.patch("/school/reassign-parent", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

